import { Component, OnDestroy, OnInit } from '@angular/core';
import { ILoaderSettings, LoaderService } from '@sd-portal/shared/shell';
import { untilViewDestroyed } from '@sd-portal/shared/rxjs';

@Component({
  selector: 'sd-loader-global',
  templateUrl: './loader-global.component.html',
  styleUrls: ['./loader-global.component.scss']
})
export class LoaderGlobalComponent implements OnInit, OnDestroy {
  hideOverlay = false;
  show = false;

  constructor(private readonly loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.loaderGlobalState
      .pipe(untilViewDestroyed(this))
      .subscribe((loaderSettings: ILoaderSettings) => {
        this.show = loaderSettings.visible;
        this.hideOverlay = loaderSettings.hideOverlay;
      });
  }

  ngOnDestroy() {
    // for ngUnsubscribe AOT
  }
}
